var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeControl = function SvgTimeControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m2.2 20.586 3.161-3.16a4 4 0 0 1 2.828-1.172h6.338c.813 0 1.473.66 1.473 1.473v0c0 .814-.66 1.473-1.473 1.473H11m-4.628 4.444h7.639c.327 0 .654-.125.903-.374l6.399-6.399c.725-.725.725-1.9 0-2.626v0a1.857 1.857 0 0 0-2.626 0l-2.479 2.48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.143,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12 3.643v3.5l2 1.5"
  }))));
};
export default SvgTimeControl;